import React from 'react';
import { motion } from 'framer-motion';
import { Calendar, MapPin, ArrowRight } from 'lucide-react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import sessionArt from '../assets/aigc/images/sound-bath-session_1771110044_000.png';

const events = [
  { 
    id: 1, 
    title: "Full Moon Sound Bath", 
    date: "October 28, 2023", 
    time: "19:00 - 21:00", 
    location: "The Sanctuary, Budapest", 
    price: "€35",
    description: "A deep immersion into sound and silence, aligning with the energy of the full moon."
  },
  { 
    id: 2, 
    title: "Deep Rest Immersion", 
    date: "November 12, 2023", 
    time: "10:00 - 16:00", 
    location: "Yoga Studio, Vienna", 
    price: "€120",
    description: "A full day retreat focused on nervous system regulation and deep restorative practices."
  },
  { 
    id: 3, 
    title: "Winter Solstice Ceremony", 
    date: "December 21, 2023", 
    time: "18:00 - 22:00", 
    location: "The Sanctuary, Budapest", 
    price: "€50",
    description: "Honoring the longest night with a journey through darkness into light."
  },
];

const Programs = () => {
  return (
    <div className="bg-background min-h-screen text-text font-sans selection:bg-secondary selection:text-background">
      <Navbar />
      
      <div className="pt-32 pb-24 container mx-auto px-6">
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="text-center mb-16"
        >
          <span className="text-secondary text-xs font-sans uppercase tracking-[0.3em] block mb-4">In Person</span>
          <h1 className="text-5xl md:text-6xl font-serif text-white mb-6">Programs & Sessions</h1>
          <p className="text-text-muted max-w-2xl mx-auto font-light leading-relaxed">
            Personally guided sound-bath experiences and events. Limited participation, application-based registration.
          </p>
        </motion.div>

        <div className="max-w-4xl mx-auto space-y-8">
          {events.map((event, index) => (
            <motion.div
              key={event.id}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="group bg-surface rounded-sm overflow-hidden hover:bg-white/5 transition-colors duration-300 flex flex-col md:flex-row"
            >
              <div className="md:w-1/3 relative h-48 md:h-auto overflow-hidden">
                <img src={sessionArt} alt={event.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110 opacity-80 group-hover:opacity-100" />
                <div className="absolute inset-0 bg-black/20 group-hover:bg-black/0 transition-colors duration-500"></div>
              </div>
              
              <div className="p-8 md:w-2/3 flex flex-col justify-between">
                <div>
                  <div className="flex justify-between items-start mb-4">
                    <h3 className="text-2xl font-serif text-white group-hover:text-secondary transition-colors">{event.title}</h3>
                    <span className="text-white font-serif bg-white/5 px-3 py-1 rounded-full text-sm">{event.price}</span>
                  </div>
                  
                  <div className="flex flex-col gap-2 mb-6 text-text-muted text-sm">
                    <div className="flex items-center gap-2">
                      <Calendar size={16} className="text-secondary" /> {event.date} • {event.time}
                    </div>
                    <div className="flex items-center gap-2">
                      <MapPin size={16} className="text-secondary" /> {event.location}
                    </div>
                  </div>
                  
                  <p className="text-text-muted/80 font-light mb-6">
                    {event.description}
                  </p>
                </div>
                
                <div>
                  <button className="inline-flex items-center text-secondary hover:text-white transition-colors uppercase tracking-widest text-xs font-medium border border-secondary/30 hover:border-white px-6 py-3 rounded-full">
                    Register Now <ArrowRight size={14} className="ml-2" />
                  </button>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Programs;
